import Departments from './Departments';

const existingKidsSizes = [
  { min: 2, max: 2, suffix: 'Y' },
  { min: 3, max: 3, suffix: 'Y' },
  { min: 4, max: 4, suffix: 'Y' },
  { min: 5, max: 5, suffix: 'Y' },
  { min: 6, max: 6, suffix: 'Y' },
  { min: 8, max: 8, suffix: 'Y' },
  { min: 10, max: 10, suffix: 'Y' },
  { min: 12, max: 12, suffix: 'Y' }
];

const existingBabiesSizes = [
  { min: 0, max: 3, suffix: 'M' },
  { min: 3, max: 6, suffix: 'M' },
  { min: 6, max: 9, suffix: 'M' },
  { min: 9, max: 12, suffix: 'M' },
  { min: 12, max: 18, suffix: 'M' },
  { min: 18, max: 24, suffix: 'M' },
  { min: 24, max: 36, suffix: 'M' }
];
const sizeData = {
  [Departments.getMenInternalName()]: ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'XXXXXL'],
  [Departments.getWomenInternalName()]: ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
  [Departments.getBoysInternalName()]: existingKidsSizes,
  [Departments.getGirlsInternalName()]: existingKidsSizes,
  [Departments.getBabyBoysInternalName()]: existingBabiesSizes,
  [Departments.getBabyGirlsInternalName()]: existingBabiesSizes
};

const isAdultDepartment = department => Departments.getAdultsDepartmentsInternalNames().includes(department);

const isAdultSize = crossCategorySize => isAdultDepartment(crossCategorySize.departmentName);

class CrossCategorySizeData {
  static all(department) {
    if (!sizeData[department]) {
      return [];
    }
    return sizeData[department].map(el => new CrossCategorySizeData(department, el));
  }

  static fromStringRepresentation(string, department) {
    const adultSize = parseAdultSize(string, department);
    const kidsSize = parseKidsSize(string, department);
    return adultSize || kidsSize;
  }

  constructor(departmentName, size) {
    this.departmentName = departmentName;
    this.size = size;
  }

  toDisplayString() {
    if (isAdultSize(this)) {
      return this.size;
    }
    return displayStringKids(this);
  }

  toLongDisplayString() {
    return this.toDisplayString();
  }

  toStringRepresentation() {
    if (isAdultSize(this)) {
      return this.size;
    }
    let prefix = Departments.getJuniorKidsDepartmentsInternalNames().includes(this.departmentName) ? 'K' : 'B';
    prefix = `${prefix}_`;

    if (this.size.min !== this.size.max) {
      return `${prefix}${this.size.min}-${this.size.max}${this.size.suffix}`;
    }
    return `${prefix}${this.size.min}${this.size.suffix}`;
  }
}

const parseAdultSize = (string, department) => {
  if (isAdultDepartment(department)) {
    return new CrossCategorySizeData(department, string);
  }
  return null;
};

// i.e. B_0-3M B_3-6M  K_10Y
const parseKidsSize = (string, department) => {
  const regex = /([KB])_(.*)([MY])/;

  const found = string.match(regex);
  if (!found) {
    return null;
  }

  const sizeString = found[2];
  const sizeSuffix = found[3];
  const rangeRegex = /(.*)-(.*)/;
  const foundRange = sizeString.match(rangeRegex);
  if (foundRange) {
    return new CrossCategorySizeData(department, {
      min: parseFloat(foundRange[1]),
      max: parseFloat(foundRange[2]),
      suffix: sizeSuffix
    });
  }
  return new CrossCategorySizeData(department, {
    min: parseFloat(sizeString),
    max: parseFloat(sizeString),
    suffix: sizeSuffix
  });
};

const displayStringKids = crossCategorySizeData => {
  const s = crossCategorySizeData.size.suffix === 'M' ? crossCategorySizeData.size.suffix : 'YRS';

  if (crossCategorySizeData.size.min !== crossCategorySizeData.size.max) {
    return `${crossCategorySizeData.size.min} - ${crossCategorySizeData.size.max} ${s}`;
  }
  return `${crossCategorySizeData.size.min} ${s}`;
};

export { CrossCategorySizeData };
